import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import LoanDisbursementPageUI from './LoanDisbursementPageUI.js'

class LoanDisbursementPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      loanBankAccount: null,
    }
  }

  render() {
    return (
      <LoanDisbursementPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        loanBankAccount={this.state.loanBankAccount}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState(
      {errorList: response.errorList, loan : response.loan},
      this.getBankAccounts(context, response.loan.accountId)
    )
  }

  getBankAccounts(context, accountId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}/bankAccounts`,
      cacheKey: CacheKeys.BankAccounts2(accountId),
      callback: this.getBankAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBankAccountsCallback = (response) => {
    let loanAcc = response.bankAccountList.filter(ba => ba.purpose === 'loan')
    if (loanAcc.length > 0) {
      this.setState({
        loanBankAccount : loanAcc[0],
        errorList: response.errorList
      })
    }
  }

  onRefreshClick = (noBusy) => {
    let loan = this.state.loan
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(loan.loanId))
    CacheManager.removeObject(CacheKeys.BankAccounts2(loan.accountId))
    if (noBusy === 'noBusy') {
      this.getLoan(context)
    }
    else {
      this.setState({
        loan: null,
        errorList: null,
      })
      this.getLoan(context)
    }
  }
}

export default withRouter(LoanDisbursementPageSF)
